import React from 'react';

type SessionInvalidatedModalProps = {
  onLogout: () => void;
};

const SessionInvalidatedModal: React.FC<SessionInvalidatedModalProps> = ({ onLogout }) => {
  return (
    <div className="modal-backdrop session-invalidated-backdrop" role="alertdialog" aria-modal="true" aria-labelledby="session-invalidated-title">
      <div className="modal-card session-invalidated-card">
        <div id="session-invalidated-title" className="section-title">Account security alert</div>
        <p style={{ margin: '0 0 16px', color: '#4a5568', lineHeight: 1.5 }}>
          Somebody signed in to your account from another device or browser, so this session is no longer valid.
          For your protection, please log out and change your password as soon as possible.
        </p>
        <div className="modal-actions">
          <button type="button" className="btn btn-primary" onClick={onLogout}>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionInvalidatedModal;
